import { render, staticRenderFns } from "./MandateTransactionsBulk.vue?vue&type=template&id=5d51f1e3&scoped=true&"
import script from "./MandateTransactionsBulk.vue?vue&type=script&lang=js&"
export * from "./MandateTransactionsBulk.vue?vue&type=script&lang=js&"
import style0 from "./MandateTransactionsBulk.vue?vue&type=style&index=0&id=5d51f1e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d51f1e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d51f1e3')) {
      api.createRecord('5d51f1e3', component.options)
    } else {
      api.reload('5d51f1e3', component.options)
    }
    module.hot.accept("./MandateTransactionsBulk.vue?vue&type=template&id=5d51f1e3&scoped=true&", function () {
      api.rerender('5d51f1e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/MandateTransactionsBulk.vue"
export default component.exports